import config from 'SRC/config/config.json'

export const getCannonicalUrl = (path, lang) => {
  if (lang !== 'me') return `https://autodiler.me/${lang}${path}`
  return `https://autodiler.me${path}`
}
